export default __webpack_public_path__ + "static/media/Alone in Nature .aa5171b9.jpg";